import { createAction, props } from '@ngrx/store'
import { HubtypeCaseFilter } from 'models/hubtype-case-filter'
import { HubtypeCaseSort } from 'models/hubtype-case-sort'
import { AddonId } from '../constants/addons'

export type AppLang = 'en' | 'es'

export const setAgentsRealtimeColumns = createAction(
  '[Agents Realtime] Set Table Columns',
  props<{ columnsByKey: Record<string, boolean> }>()
)

export const toggleNavbarCollapse = createAction(
  '[Desk] Toggle Navbar Collapse'
)

export const setNavbarCollapse = createAction(
  '[Desk] Set Navbar Collapse',
  props<{ value: boolean }>()
)

export const toggleQueuePanelCollapse = createAction(
  '[Inbox] Toggle Queue Panel Collapse'
)

export const setUseInboxV2 = createAction(
  '[Inbox] Set Use Inbox V2',
  props<{ useInboxV2: boolean }>()
)

export const setInboxCasesSort = createAction(
  '[Inbox] Set Inbox Cases Sort',
  props<{ inboxCasesSort: HubtypeCaseSort }>()
)

export const setInboxCasesFilter = createAction(
  '[Inbox] Set Inbox Cases Filter',
  props<{ inboxCasesFilter: HubtypeCaseFilter }>()
)

export const setInboxSelectedQueues = createAction(
  '[Inbox] Set Inbox Selected Queues',
  props<{ inboxSelectedQueueIds: string[] }>()
)

export const setAnalyticsDebugEventsVisible = createAction(
  '[Analytics] Set Debug Events Visible',
  props<{ visible: boolean }>()
)

export const setCopilotSidePanelWidth = createAction(
  '[Analytics Copilot] Set Side Panel Width',
  props<{ width: number }>()
)

export const setAddonContactRequested = createAction(
  '[Addons] Set Contact Requested',
  props<{ addonId: AddonId }>()
)

export const setCopilotQueryRating = createAction(
  '[Analytics Copilot] Set Query Rating',
  props<{ messageId: string; rating: 'positive' | 'negative' }>()
)

export const setLang = createAction(
  '[User Settings] Set Language',
  props<{ lang: AppLang }>()
)

export const setAwayModalDismissed = createAction(
  '[User Settings] Set Away Modal Dismissed',
  props<{ value: boolean }>()
)
